<template>
  <power-bi code="eyJrIjoiYTViOTJkNTctYTk3OC00ZGYxLWIyNDQtOTI4Yzk1ODAyNGQzIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
